<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999999999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container grid-list-md>
      <p style="font-size: 20px;font-weight: bold;">
        فاتورة بيع من المخزن باستخدام الباركود
      </p>
      <v-text-field
      ref="barcode"
        height="5"
        outline
        v-model="item_barcode"
        label="Bar-Code"
        @change="add_item()"
      ></v-text-field>
      <v-layout wrap>
        <v-flex xs12 sm6 md2> </v-flex>
        <v-flex xs12 sm6 md2> {{ count }} </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field height="5" outline label="Test"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="set_code">click</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      item_barcode: "",
      count: 0
    };
  },
  methods: {
    add_item() {
        setTimeout(() => {
            this.count++;
            this.item_barcode = "";
        }, 10);
    },
    set_code() {
        setTimeout(() => {
            console.log(this.$refs['barcode'].value)
            // this.item_barcode = '123'
            this.$refs['barcode'].value = '123'
            
        }, 10);
    }
  }
};
</script>
